import { WhyApplying } from "@up/application-fields";

import type { ReactNode } from "react";

export function PersonalStatementPage({ bottom }: { bottom: () => ReactNode }) {
  return (
    <>
      <WhyApplying />
      {bottom()}
    </>
  );
}
